import React, {createContext, PureComponent} from 'react';
import {GlobalContextI, GlobalContextProviderProps} from "./Context.types";
import {routes} from "app/router";
import Moment from 'moment';

export const GlobalContext = createContext<GlobalContextI>({
  user: {
    first: '',
    last: '',
  },
  loading: false,
  routes,
  logout: () => {},
  setContext: () => {}
});

export class GlobalContextProvider extends PureComponent<GlobalContextProviderProps, GlobalContextI> {

  setContext = ( changes: Partial<GlobalContextI>): void => {
    this.setState({
      ...this.state,
      ...changes
    })
  }

  logout() {
    localStorage.removeItem('token');
    this.setState({...this.state, user: {...this.state?.user, token: undefined}});
  }

  getSessionToken() {
    const token = localStorage.getItem('submissionToken');
    const loginTimeStamp = localStorage.getItem('loginTimeStamp');

    if(token !== null) {
      const parsedToken = JSON.parse(token);
      if(Moment(parsedToken?.timeStamp).isBefore(Moment().subtract(30, 'minutes'))) {
        return parsedToken;
      }
    }
    return undefined;
  }

  state: GlobalContextI = {
    user: {
      first: '',
      last: ''
    },
    loading: true,
    submissionStamp: localStorage.getItem('submissionToken') ?? undefined,
    routes: routes,
    logout: () => this.logout(),
    setContext: this.setContext
  }

  componentDidMount(): void {
    const token = this.getSessionToken();
    this.setState({...this.state, user: {...this.state.user, token}})
  }

  render() {
    return (
        <GlobalContext.Provider value={this.state}>
          {this.props.children}
        </GlobalContext.Provider>
    )
  }

}